import React from 'react';
import { FileText } from 'lucide-react';
import { AvatarImage } from '@/components/ui/avatar';
import { useProtectedSrc } from '@/lib/protectedFile';

/** <img> para archivos que requieren sesión. Si el archivo no es una imagen (p. ej. un PDF) muestra un ícono. */
export const ProtectedImage = ({ src, alt = '', className = '', fallbackClassName = '', ...rest }) => {
  const { src: resolved, type, failed } = useProtectedSrc(src);
  const notImage = failed || (type && type !== 'direct' && !type.startsWith('image/'));
  if (notImage) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 text-gray-400 ${fallbackClassName || className}`} aria-label={alt}>
        <FileText className="w-1/3 h-1/3 min-w-6 min-h-6" />
      </div>
    );
  }
  if (!resolved) return <div className={`animate-pulse bg-gray-100 ${fallbackClassName || className}`} aria-hidden="true" />;
  return <img src={resolved} alt={alt} className={className} {...rest} />;
};

/** AvatarImage que resuelve fotos subidas como archivo (las que ya están en base64 pasan directo). */
export const ProtectedAvatarImage = ({ src, ...rest }) => {
  const { src: resolved } = useProtectedSrc(src);
  return resolved ? <AvatarImage src={resolved} {...rest} /> : null;
};

export default ProtectedImage;
